import clsx from 'clsx';

import {Icon} from '../Icon/Icon';

import type {IconProp} from '@fortawesome/fontawesome-svg-core';
import type {FontAwesomeIconProps} from '@fortawesome/react-fontawesome';
import type React from 'react';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: IconProp;
  size?: FontAwesomeIconProps['size'];
  iconExtras?: Omit<FontAwesomeIconProps, 'size'>;
  colour?: 'blue' | 'tomato' | 'grass' | 'amber' | 'slate';
};
export const IconButton = ({
  ref,
  icon,
  size,
  iconExtras,
  colour,
  className,
  ...props
}: Props & {
  ref?: React.RefObject<HTMLButtonElement>;
}) => {
  return (
    <button
      ref={ref}
      type="button"
      {...props}
      className={clsx(
        className,
        'leading-none hover:cursor-pointer hover:outline-hidden focus:outline-hidden disabled:text-slate9 disabled:hover:cursor-default disabled:hover:text-inherit',
        colour === 'tomato'
          ? 'text-tomato9 hover:text-tomato10 focus-visible:text-tomato10'
          : colour === 'grass'
            ? 'text-grass9 hover:text-grass10 focus-visible:text-grass10'
            : colour === 'amber'
              ? 'text-amber9 hover:text-amber10 focus-visible:text-amber10'
              : colour === 'slate'
                ? 'text-slate9 hover:text-slate10 focus-visible:text-slate10'
                : 'text-blue9 hover:text-blue10 focus-visible:text-blue10'
      )}
    >
      <Icon icon={icon} size={size} {...iconExtras} />
    </button>
  );
};
IconButton.displayName = 'IconButton';
